import { FC, useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { Box, Typography, IconButton, Button } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { styles } from "./stylesLikeUndoModal";
import Isvg from "@/assets/svg/Isvg";
import { formatMoney } from "@/helpers/formatMoney";

type Props = {
  username: string;
  amount: string;
  onCancel: () => void;
  onClose: () => void;
};

const LikeUndoModal: FC<Props> = ({ username, amount, onCancel, onClose }) => {
  const [secondsLeft, setSecondsLeft] = useState(5);
  const onCloseRef = useRef(onClose);
  onCloseRef.current = onClose;

  useEffect(() => {
    let count = 5;
    const timer = setInterval(() => {
      count -= 1;
      setSecondsLeft(count);
      if (count === 0) {
        clearInterval(timer);
        onCloseRef.current();
      }
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  return createPortal(
    <Box sx={styles.modal}>
      {/* Header */}
      <Box sx={styles.header}>
        <Box sx={styles.headerLeft}>
          <Isvg />
          <Typography sx={styles.reminderText}>Reminder</Typography>
        </Box>
        <IconButton onClick={onClose} sx={styles.closeButton}>
          <CloseIcon sx={{ width: 18, height: 18, color: "#2A2D31" }} />
        </IconButton>
      </Box>

      {/* Message */}
      <Typography sx={styles.message}>
        Sending a like you confirm to send ${formatMoney(amount)} USDC to user{" "}
        <Typography component="span" sx={styles.username}>
          {username}
        </Typography>
        .
      </Typography>

      {/* Cancel button */}
      <Button onClick={onCancel} sx={styles.cancelButton}>
        <Typography sx={styles.cancelText}>Cancel</Typography>
        <Typography sx={styles.timerText}>{secondsLeft} sec.</Typography>
      </Button>
    </Box>,
    document.body
  );
};

export default LikeUndoModal;
